import { Navigate } from "react-router-dom";

function GeneratePage() {
  return <Navigate to="/studio" replace />;
}

export default GeneratePage;
